import store from '@/store';

export default (to, from, next) => {

    const is_account_type_activated_fwa = store.getters.is_account_type_activated_fwa
    
    return {
        allow: is_account_type_activated_fwa,
        redirect: { name: 'not-found' },
    };
};